import { useEffect } from 'react';

import { useDeepCompareMemoize } from '../../../hooks';
import { useFetchHotelRooms } from './useFetchHotelRooms';

import { convertNightsToDatesParams } from '../utils';

interface IUseGetHotelRooms {
  areSmallCards: boolean;
  isInitial: boolean;
  searchParams: any;
  updateWidgetState: any;
  setIsSearchCompleted: any;
}

export const useGetHotelRooms = (params: IUseGetHotelRooms): void => {
  const { areSmallCards, isInitial, searchParams, updateWidgetState, setIsSearchCompleted } =
    params;
  const getHotelRooms = useFetchHotelRooms();

  useEffect(() => {
    if (!getHotelRooms) {
      return;
    }

    const searchParamsWithoutNights = convertNightsToDatesParams(searchParams, areSmallCards);

    getHotelRooms({
      setHotelRooms: (hotelRooms) => {
        updateWidgetState((widgetState: Record<string, any>) => ({ ...widgetState, hotelRooms }));
      },
      searchParams: searchParamsWithoutNights,
      isInitial,
    }).then(() => {
      setIsSearchCompleted(true);
    });
  }, [areSmallCards, useDeepCompareMemoize(searchParams)]);
};
